import React, { useMemo } from 'react';
import { FlexColumn, SvgIcon, useCountdown } from '@make-software/tg-mini-app-ui';

import { TimestampInput } from '@/entities';
import { formatMonthDay } from '@/utils';
import CalendarIcon from '@/shared/assets/icons/ic-calendar.svg';

import {
  RoundActivityCardContainer,
  SvgIconContainer,
  CardTopRow,
  LeftSide,
  CardTitle,
  CardSubtitle,
  CountdownWrap,
  CountdownUnit,
  CountdownValue,
  CountdownLabel,
  CountdownDivider
} from '../styled';

interface Round2ActivityCardProps {
  startsAt?: TimestampInput;
  bgColor?: string;
  withCountdown?: boolean;
}

const toCountdownTarget = (value?: TimestampInput): string | number | null => {
  if (!value) return null;
  if (typeof value === 'number') return value;
  if (typeof value === 'string') return value;
  if (value instanceof Date) return value.toISOString();
  return null;
};

export const Round2ActivityCard: React.FC<Round2ActivityCardProps> = ({
                                                                        startsAt,
                                                                        bgColor = '#39436B',
                                                                        withCountdown
                                                                      }) => {
  const dateLabel = useMemo(() => formatMonthDay(startsAt), [startsAt]);

  const countdownTarget = useMemo(() => toCountdownTarget(startsAt), [startsAt]);
  const { days, hours, minutes, seconds, active } = useCountdown(countdownTarget);

  return (
    <RoundActivityCardContainer bgColor={bgColor}>
      <CardTopRow>
        <LeftSide>
          <SvgIconContainer>
            <SvgIcon src={CalendarIcon} size={22} />
          </SvgIconContainer>

          <FlexColumn gap={2} style={{ minWidth: 0 }}>
            <CardTitle weight={3} color="#FFFFFF">
              Round 2 - Final starts
            </CardTitle>

            {!!dateLabel && (
              <CardSubtitle weight={3} size="sm">
                {dateLabel}
              </CardSubtitle>
            )}
          </FlexColumn>
        </LeftSide>

        {!!withCountdown && active && (
          <CountdownWrap aria-label="Round 2 countdown">
            <CountdownUnit>
              <CountdownValue>{days}</CountdownValue>
              <CountdownLabel>D</CountdownLabel>
            </CountdownUnit>

            <CountdownDivider />

            <CountdownUnit>
              <CountdownValue>{hours}</CountdownValue>
              <CountdownLabel>H</CountdownLabel>
            </CountdownUnit>

            <CountdownDivider />

            <CountdownUnit>
              <CountdownValue>{minutes}</CountdownValue>
              <CountdownLabel>M</CountdownLabel>
            </CountdownUnit>

            <CountdownDivider />

            <CountdownUnit>
              <CountdownValue>{seconds}</CountdownValue>
              <CountdownLabel>S</CountdownLabel>
            </CountdownUnit>
          </CountdownWrap>
        )}
      </CardTopRow>
    </RoundActivityCardContainer>
  );
};
